const grill = [
  {
    regNum: 1,
    item: "tebasaki",
    desc: "chicken wings"
  },
  {
    regNum: 2,
    item: "tsukune",
    desc: "chicken meat balls"
  },
  {
    regNum: 3,
    item: "negima",
    desc: "dark chicken meat with scallions"
  },
  {
    regNum: 4,
    item: "sasami",
    desc: "white meat - shio, tare, yuzu kosho, wasabi, ume"
  },
  {
    regNum: 5,
    item: "chicken with shiso",
    desc: "white meat wrapped with shiso leaf"
  },
  {
    regNum: 7,
    item: "kawa",
    desc: "chicken skin - shio or tare"
  },
  {
    regNum: 8,
    item: "sunagimo",
    desc: "chicken giblets"
  },
  {
    regNum: 9,
    item: "kimo",
    desc: "chicken liver - shio or tare"
  },
  {
    regNum: 10,
    item: "hatsu",
    desc: "chicken hearts"
  },
  {
    regNum: 12,
    item: "bonbochi",
    desc: "chicken tail"
  },
  {
    regNum: 13,
    item: "nankotsu",
    desc: "leg bone cartilage"
  },
  {
    regNum: 14,
    item: "yagen",
    desc: "breast bone cartilage"
  },
  {
    regNum: 15,
    item: "tsukimi",
    desc: "neck meat"
  },
  {
    regNum: 16,
    item: "motsu yaki",
    desc: "kidney"
  },
  {
    regNum: 17,
    item: "nanban yaki",
    desc: "thin slices of new york steak"
  },
  {
    regNum: 18,
    item: "tan",
    desc: "beef tongue"
  },
  {
    regNum: 20,
    item: "kaibashira",
    desc: "size u-10 scallop - 1"
  },
  {
    regNum: 21,
    item: "ebi",
    desc: "size 8/12 shrimp - 1"
  },
  {
    regNum: 22,
    item: "shishamo",
    desc: "dried smelt"
  },
  {
    regNum: 23,
    item: "shiromi",
    desc: "chilean sea bass"
  },
  {
    regNum: 25,
    item: "shake",
    desc: "salmon"
  },
  {
    regNum: 26,
    item: "ika",
    desc: "squid"
  },
  {
    regNum: 27,
    item: "geso",
    desc: "squid legs"
  },
  {
    regNum: 30,
    item: "aspara maki",
    desc: "asparagus wrapped with side pork"
  },
  {
    regNum: 31,
    item: "okra maki",
    desc: "okra wrapped with side pork"
  },
  {
    regNum: 32,
    item: "gobo maki",
    desc: "burdock wrapped with side pork"
  },
  {
    regNum: 33,
    item: "nasu",
    desc: "japanese eggplant"
  },
  {
    regNum: 34,
    item: "shishito",
    desc: "small japanese green pepper"
  },
  {
    regNum: 35,
    item: "yasai yaki",
    desc: "cherry tomatoes, green pepper, mushroom"
  },
  {
    regNum: 36,
    item: "shiitake",
    desc: "japanese mushroom"
  },
  {
    regNum: 37,
    item: "shimeji",
    desc: "oyster mushroom"
  },
  {
    regNum: 38,
    item: "ginnan",
    desc: "gingko nuts"
  },
  {
    regNum: 39,
    item: "shiso maki",
    desc: "pork loin wrapped with shiso"
  },
  {
    regNum: 40,
    item: "uzura",
    desc: "quail egg"
  },
  {
    regNum: 41,
    item: "nanban complete dinner - rice",
    desc: "aspara maki (1), shiso maki (1), tebasaki (1), yasai yaki (1), uzura (1), nanban yaki (2), tsukune (1), negima (1), miso soup, pickles, rice, ice cream"
  },
  {
    regNum: 42,
    item: "nanban complete dinner - soboro don",
    desc: "aspara maki (1), shiso maki (1), tebasaki (1), yasai yaki (1), uzura (1), nanban yaki (2), tsukune (1), negima (1), miso soup, pickles, rice, ice cream"
  }
]

export default grill;